<script setup>

    import {ref} from "vue";
    import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";
    import EditableBtn from "./portal-editable-fields/EditableBtn.vue";

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const emit = defineEmits(['modal-off']);

    const deleteUrl = route('partners_int.custom_links.delete')

    const props = defineProps({
        id: {
            type: Number,
            required: true
        },
        url: {
            type: String,
            required: true
        }
    })
    const error = ref(false)
    const loading = ref(false)
    const deleteRefLinkModal = ref(null)

    const deleteCustomLink = () => {

        if (loading.value) {
            return;
        }

        error.value = false;
        loading.value = true;

        axios
            .post(deleteUrl, {link_id: props.id})
            .then(response => {
                const status = parseInt(response.data.status ?? 0);
                if (status === 1) {
                    if (deleteRefLinkModal.value) {
                        deleteRefLinkModal.value.showModal = false;
                    }
                    portalContentAndDesignStore.resourcesPageSettings.custom_links = portalContentAndDesignStore.resourcesPageSettings.custom_links.filter(link => link.id !== props.id);
                    emit('modal-off', 'partner_delete_custom_link');
                } else {
                    error.value = 'Failed to delete custom link';
                }
            })
            .catch(error => {
                let errors = error.response.data.error || false;
                error.value = Array.isArray(errors) ? errors[0] : errors;
            }).finally(() => loading.value = false);
    }
</script>
<template>
    <modal
        :title="portalContentAndDesignStore.translationSettings.portal_translation_general_delete"
        size="small"
        :cancel_btn_title="portalContentAndDesignStore.translationSettings.portal_translation_general_cancel"
        name="partner_delete_custom_link"
        ref="deleteRefLinkModal"
    >
        <template #toggle>
            <options-item title="Delete"/>
        </template>
        <template #body>
            <fieldset>
                <div class="-space-y-px bg-white rounded-md text-left">
                    {{ portalContentAndDesignStore.translationSettings.portal_translation_features_delete_custom_ref_question }}
                </div>
                <div class="-space-y-px bg-white rounded-md text-left">
                    {{ url }}
                </div>
            </fieldset>
            <div class="space-y-6" v-if="error">
                <span class="text-red-600 text-sm">{{ error }}</span>
            </div>
        </template>
        <template #footer>
            <editable-btn
                v-on:click="deleteCustomLink"
                :loading="loading"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_yes_delete"
            />
        </template>
    </modal>
</template>

